<template>
  <div class="heading__primary">
<span class="heading__primary-btn">
  <router-link to="/"> 
<a href="#" class="btn__text" v-if="!torrespanorama">Volver al plan maestro</a>
  
  </router-link>

</span>
<span class="heading__primary-btn">
<a :href="this.micrositeUrl"  class="btn__text">Ir al micrositio</a>
<!-- @click.prevent="goToMicrosite()" -->
</span>

  </div>
</template>

<script>
export default {
  name: "SubHeader",
  props: ["micrositeUrl",'torrespanorama'],
  methods: {
    goToMicrosite(){
      window.open(this.micrositeUrl, "_blank")
    }
  }
};
</script>
